export const TestingStatuses = {
  INITIAL: 'initial',
  FAILURE: 'failure',
  SUCCESS: 'success',
  TESTING: 'testing',
};

export const NEW_AUTH_FORM = 'new-auth-form';
